export function activateGoogleOptimize() {
  const windowAny = window as any

  if (windowAny.dataLayer) windowAny.dataLayer.push({ event: 'optimize.activate' })
}
